import authSvc from './authSvc'
import objectToFormData from 'object-to-formdata'

export default class apiRes {
  static instance = null
  static previousAlert = null
  static previousAlertTime = null
  static baseUrl = process.env.VUE_APP_BASE_API_URL
    ? process.env.VUE_APP_BASE_API_URL
    : location.origin

  static getUrl(url) {
    return url.indexOf(apiRes.baseUrl) === 0 ? url : apiRes.baseUrl + url
  }

  static get(url) {
    return fetch(apiRes.getUrl(url), {
      credentials: 'include'
    })
      .then(resp => resp.json())
      .then(data => {
        if (data.alert && apiRes.handleAlert(data.alert)) return null

        if (data.error) {
          apiRes.handleError(data.error)
          return null
        } else if (data.error_form && typeof data.error_form === 'object') {
          apiRes.handleError(data.error_form)
          return null
        } else if (data.redirect_uri) {
          return apiRes.get(data.redirect_uri)
        } else {
          if (data.main_vars) authSvc.setSessionData(data.main_vars)
          return data
        }
      })
  }

  static post(url, body, getRedirectUrl) {
    for (var name in body) {
      var val = body[name]
      if (val && val.getTime) {
        body[name] = [
          val.getFullYear(),
          val.getMonth() + 1,
          val.getDate()
        ].join('/')
      }
    }

    let formData = objectToFormData(body, { indices: true })

    return fetch(apiRes.getUrl(url), {
      method: 'POST',
      body: formData,
      credentials: 'include'
    })
      .then(resp => resp.json())
      .then(data => {
        if (data.alert) {
          apiRes.handleAlert(data.alert)
        }

        if (data.error) {
          apiRes.handleError(data.error)
          return null
        } else if (data.error_form && typeof data.error_form === 'object') {
          apiRes.handleError(data.error_form)
          return null
        } else if (data.redirect_uri) {
          return getRedirectUrl
            ? data.redirect_uri
            : apiRes.get(data.redirect_uri)
        } else {
          return data
        }
      })
  }

  static handleAlert(alert) {
    if (alert) {
      let alertMsg = `<div>${alert.messages.join('<br/>')}</div>`
      if (
        this.previousAlert !== alertMsg ||
        !this.previousAlertTime ||
        Date.now() - this.previousAlertTime > 1000
      ) {
        this.previousAlert = alertMsg
        this.previousAlertTime = Date.now()
        this.instance.$notify.info({
          message: this.previousAlert,
          dangerouslyUseHTMLString: true
        })
      }
    }

    return alert.code === 1
  }

  static handleError(error) {
    if (error) {
      var errors
      if (error.length) {
        if (typeof error === 'string') {
          errors = [error]
        } else if (typeof error[0] === 'string') {
          errors = [error[0]]
        } else {
          errors = error.map(e => e.field.split(' ').map(f => this.instance.$t(f)).join(' ') + ': ' + this.instance.$t(e.error))
        }
      } else if (typeof error === 'object') {
        errors = [JSON.stringify(error)]
      }

      if (errors.length) {
        this.instance.$alert(
          `<div>${errors.map(e => this.instance.$t(e)).join('<br/>')}</div>`,
          this.instance.$t('error'),
          { type: 'error', dangerouslyUseHTMLString: true }
        )
      }

      return null
    }
  }

  static setMenu(menu) {
    apiRes.profileUrl = menu['setup.profile'] ? menu['setup.profile'].url : null
    apiRes.statisticUrl = menu['setup.stat'] ? menu['setup.stat'].url : null
    apiRes.invoicesUrl = menu['invoice.search']
      ? menu['invoice.search'].url
      : null
    apiRes.usersUrl = menu['account.search'] ? menu['account.search'].url : null
    apiRes.paymentsUrl = menu['transaction.search']
      ? menu['transaction.search'].url
      : null
    apiRes.paymentsLogUrl = menu['transaction_log.search']
      ? menu['transaction_log.search'].url
      : null
    apiRes.addInvoiceUrl = menu['invoice.add_invoice']
      ? menu['invoice.add_invoice'].url
      : null
    apiRes.addUserUrl = menu['account.add'] ? menu['account.add'].url : null

    apiRes.idcheckClients = menu['idcheck.clients']
      ? menu['idcheck.clients'].url
      : null
    apiRes.idcheckRequests = menu['idcheck.requests']
      ? menu['idcheck.requests'].url
      : null
    apiRes.idcheckRequestsInfo = menu['idcheck.requests_info']
      ? menu['idcheck.requests_info'].url
      : null
    apiRes.idcheckTemplates = menu['idcheck.templates']
      ? menu['idcheck.templates'].url
      : null
    apiRes.idcheckInfo = menu['idcheck.info'] ? menu['idcheck.info'].url : null
    apiRes.qrUrl = menu['qr.view'] ? menu['qr.view'].url : null
    apiRes.qrReports = menu['report.qr'] ? menu['report.qr'].url : null
    apiRes.qrReportParams = menu['report.qr'] ? menu['report.qr'].url : null
    apiRes.productsUrl = menu['product.search'] ? menu['product.search'].url : null
    apiRes.productAdd = menu['product.search'] ? menu['product.add'].url : null
    apiRes.bankReports = menu['report.issuing_banks'] ? menu['report.issuing_banks'].url : null
    apiRes.subTransactionsReports = menu['report.sub_transactions'] ? menu['report.sub_transactions'].url : null
    apiRes.errorsUrl = menu['error_info.view'] ? menu['error_info.view'].url : null
    // apiRes.bankReportParams = menu['report.issuing_banks'] ? menu['report.issuing_banks'].url : null
  }

  static get statisticUrl() {
    return window.localStorage['stat']
  }

  static set statisticUrl(val) {
    if (val && val.length) {
      window.localStorage.setItem('stat', val)
    } else {
      window.localStorage.removeItem('stat')
    }
  }

  static get profileUrl() {
    return window.localStorage['profile']
  }

  static set profileUrl(val) {
    if (val && val.length) {
      window.localStorage.setItem('profile', val)
    } else {
      window.localStorage.removeItem('profile')
    }
  }

  static get payoutSettings() {
    return window.localStorage['payoutSettings']
  }

  static set payoutSettings(val) {
    if (val) {
      window.localStorage.setItem('payoutSettings', val)
    } else {
      window.localStorage.removeItem('payoutSettings')
    }
  }

  static get invoicesUrl() {
    return window.localStorage['invoices']
  }

  static set invoicesUrl(val) {
    if (val && val.length) {
      window.localStorage.setItem('invoices', val)
    } else {
      window.localStorage.removeItem('invoices')
    }
  }

  static get addInvoiceUrl() {
    return window.localStorage['addInvoice']
  }

  static set addInvoiceUrl(val) {
    if (val && val.length) {
      window.localStorage.setItem('addInvoice', val)
    } else {
      window.localStorage.removeItem('addInvoice')
    }
  }

  static get addUserUrl() {
    return window.localStorage['addUser']
  }

  static set addUserUrl(val) {
    if (val && val.length) {
      window.localStorage.setItem('addUser', val)
    } else {
      window.localStorage.removeItem('addUser')
    }
  }

  static get usersUrl() {
    return window.localStorage['users']
  }

  static set usersUrl(val) {
    if (val && val.length) {
      window.localStorage.setItem('users', val)
    } else {
      window.localStorage.removeItem('users')
    }
  }

  static get paymentsUrl() {
    return window.localStorage['payments']
  }

  static get errorsUrl() {
    return window.localStorage['errors']
  }

  static set errorsUrl(val) {
    if (val && val.length) {
      window.localStorage.setItem('errors', val)
    } else {
      window.localStorage.removeItem('errors')
    }
  }

  static set paymentsUrl(val) {
    if (val && val.length) {
      window.localStorage.setItem('payments', val)
    } else {
      window.localStorage.removeItem('payments')
    }
  }

  static get paymentsLogUrl() {
    return window.localStorage['paymentsLog']
  }

  static set paymentsLogUrl(val) {
    if (val && val.length) {
      window.localStorage.setItem('paymentsLog', val)
    } else {
      window.localStorage.removeItem('paymentsLog')
    }
  }

  static get idcheckClients() {
    return window.localStorage['idcheck.clients']
  }

  static set idcheckClients(val) {
    if (val && val.length) {
      window.localStorage.setItem('idcheck.clients', val)
    } else {
      window.localStorage.removeItem('idcheck.clients')
    }
  }

  static get idcheckRequests() {
    return window.localStorage['idcheck.requests']
  }

  static set idcheckRequests(val) {
    if (val && val.length) {
      window.localStorage.setItem('idcheck.requests', val)
    } else {
      window.localStorage.removeItem('idcheck.requests')
    }
  }

  static get idcheckRequestsInfo() {
    return window.localStorage['idcheck.requests_info']
  }

  static set idcheckRequestsInfo(val) {
    if (val && val.length) {
      window.localStorage.setItem('idcheck.requests_info', val)
    } else {
      window.localStorage.removeItem('idcheck.requests_info')
    }
  }

  static get idcheckTemplates() {
    return window.localStorage['idcheck.templates']
  }

  static set idcheckTemplates(val) {
    if (val && val.length) {
      window.localStorage.setItem('idcheck.templates', val)
    } else {
      window.localStorage.removeItem('idcheck.templates')
    }
  }

  static get idcheckInfo() {
    return window.localStorage['idcheck.info']
  }

  static set idcheckInfo(val) {
    if (val && val.length) {
      window.localStorage.setItem('idcheck.info', val)
    } else {
      window.localStorage.removeItem('idcheck.info')
    }
  }

  static get qrUrl() {
    return window.localStorage['qr']
  }

  static set qrUrl(val) {
    if (val && val.length) {
      window.localStorage.setItem('qr', val)
    } else {
      window.localStorage.removeItem('qr')
    }
  }

  static get qrReportParams() {
    return window.localStorage['report.qr']
  }

  static set qrReportParams(val) {
    if (val && val.length) {
      window.localStorage.setItem('report.qr', val)
    } else {
      window.localStorage.removeItem('report.qr')
    }
  }

  static get bankReports() {
    return window.localStorage['report.issuing_banks']
  }

  static set bankReports(val) {
    if (val && val.length) {
      window.localStorage.setItem('report.issuing_banks', val)
    } else {
      window.localStorage.removeItem('report.issuing_banks')
    }
  }

  static get subTransactionsReports() {
    return window.localStorage['report.sub_transactions']
  }

  static set subTransactionsReports(val) {
    if (val && val.length) {
      window.localStorage.setItem('report.sub_transactions', val)
    } else {
      window.localStorage.removeItem('report.sub_transactions')
    }
  }

  static get qrReports() {
    return window.localStorage['report.qr_view']
  }

  static set qrReports(val) {
    if (val && val.length) {
      window.localStorage.setItem('report.qr_view', val)
    } else {
      window.localStorage.removeItem('report.qr_view')
    }
  }

  static get productsUrl() {
    return window.localStorage['products.view']
  }

  static set productsUrl(val) {
    if (val && val.length) {
      window.localStorage.setItem('products.view', val)
    } else {
      window.localStorage.removeItem('products.view')
    }
  }

  static get productAdd() {
    return window.localStorage['products.add']
  }

  static set productAdd(val) {
    if (val && val.length) {
      window.localStorage.setItem('products.add', val)
    } else {
      window.localStorage.removeItem('products.add')
    }
  }
}
